import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./css.css";
import "./tooltip.css";
import Survey from "./pages/Survey";
import Success from "./pages/Success";
import Cancel from "./pages/Cancel";
import GetPayment from "./pages/GetPayment";
import Report from "./adminpages/Report";
import Promos from "./adminpages/Promos";
import Progress from "./adminpages/Progress";
import Providers from "./adminpages/Providers";

function App() {
  console.log("'App' rendering...");
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path="/">
            <div style={{ padding: "20px", display: "flex" }}>
              <div
                style={{
                  backgroundColor: "white",
                  display: "inline-block",
                  margin: "auto",
                  padding: "20px",
                  border: "1px solid black",
                  borderRadius: "20px",
                }}
              >
                <h3>Complex Health Admin Interface</h3>
                <a href="./iframe">Run Survey</a>
                <br />
                <a href="./report">Report interface</a>
                <br />
                <a href="./promos">Promo maintenance</a>
                <br />
                <a href="./progress">Progress tracker</a>
                <br />
                <a href="./providers">Provider Admin</a>
                <br />
                <div>node updated - test v14</div>
              </div>
            </div>
          </Route>
          <Route exact path="/report" component={Report} />
          <Route exact path="/promos" component={Promos} />
          <Route exact path="/progress" component={Progress} />
          <Route exact path="/survey" component={Survey} />
          <Route exact path="/providers" component={Providers} />
          <Route exact path="/iframe">
            <div
              style={{
                height: "70px",
                backgroundColor: "blue",
                paddingTop: "10px",
                paddingLeft: "40px",
              }}
            >
              <h1>Simulated header</h1>
            </div>
            <iframe
              title="Survey"
              src="/survey"
              width="100%"
              height="600px"
              heightNO="32000px"
            />
            <div style={{ height: "70px", backgroundColor: "blue" }}>
              <h1>Simulated bottom header</h1>
            </div>
          </Route>
          <Route exact path="/getpayment/:dateValue" component={GetPayment} />
          <Route exact path="/success/:dateValue/:pennies">
            <Success />
          </Route>
          <Route exact path="/cancel/:dateValue" component={Cancel} />
          <Route>
            <h1 style={{ color: "orange" }}>
              Unknown route/path; I'm so sorry; I really am.
            </h1>
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
